import { render, staticRenderFns } from "./gameAll.vue?vue&type=template&id=bb67aa68&scoped=true"
import script from "./gameAll.vue?vue&type=script&lang=js"
export * from "./gameAll.vue?vue&type=script&lang=js"
import style0 from "./gameAll.vue?vue&type=style&index=0&id=bb67aa68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb67aa68",
  null
  
)

export default component.exports